import { UPDATE_BACKGROUND } from './constants'

// eslint-disable-next-line
export function updateBackground(background) {
    return {
        type: UPDATE_BACKGROUND,
        payload: background,
    }
}



// WEBPACK FOOTER //
// ./src/features/Sync/data/background/actions.js